import React, {Component} from "react";

import "./DocumentUploadingTab.css";
import {Col, Row, Typography} from "antd";
import UploadWrapper from "./UploadWrapper";
import {displayGenericError} from "../common/notifications";
import {deleteFile, deleteOriginatorAttachedFile, upload} from "../api/api";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

import "./DocumentIndividualUploadingTab.scss"
import 'react-day-picker/lib/style.css';

const {Title, Text, Paragraph} = Typography;


class DocumentOriginatorCorporateUploading extends Component {
    state = {
        documents: this.props.originator.documents || {},
        isSubmitted: false,
    }

    constructor(props) {
        super(props);
        let attachedFiles = props.originator.originatorAttachedFiles;
        if(attachedFiles && attachedFiles.length>0){
            this.state.documents["CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"]=attachedFiles.find(item => item.attachedFileType == 'CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION');
            this.state.documents["MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"]=attachedFiles.find(item => item.attachedFileType == 'MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION');
            this.state.documents["COMPANY_SEARCH_REPORT"]=attachedFiles.find(item => item.attachedFileType == 'COMPANY_SEARCH_REPORT');
            this.state.documents["BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"]=attachedFiles.find(item => item.attachedFileType == 'BOARD_RESOLUTION_FOR_ACCOUNT_OPENING');
        }
    }

    handleUpload = ({file, type}) => {
            const originator = this.props.originator;
            return upload({id: originator.id, isOriginatorUpload:true, file, type})
                .then(res => {
                    this.setState({
                        documents: {
                            ...this.state.documents,
                            [type]: {
                                name: file.name,
                                size: file.size / 1024,
                                id: res.id
                            }
                        }
                    });
                })
                .catch(displayGenericError);
    };
    handleRemoveFile = ({id, type}) => {
        const originatorid = this.props.originator.id;
        deleteOriginatorAttachedFile(originatorid,id)
            .then(() => {
                    const {documents} = this.state;
                    delete documents[type];
                    this.setState({documents});
            })
            .catch(displayGenericError);
    };
    handleCorporateSubmit = (onboardingType, dateSelect, timeSelect) => {
        this.props.updateOnboardingForm({
            dateSelect: dateSelect,
            timeSelect: timeSelect,
            onboardingType: onboardingType,

        })
    }
    isSubmitButtonDisabled = () => {
        let response = false;
        if(this.state.documentType === 'attachedDocument'){
            if(!this.state.documents['CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION'] ||
                !this.state.documents['MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION'] ||
                !this.state.documents['COMPANY_SEARCH_REPORT'] ||
                !this.state.documents['BOARD_RESOLUTION_FOR_ACCOUNT_OPENING'] ){
                return true;
            }
        }else{

        }
        return response;
    }
    handleSubmit = () => {
        this.props.updateOnboardingForm({
            dateSelect:this.state.dateSelect,
            timeSelect: this.state.selectTime,
            onboardingType:this.state.documentType,
            documents:this.state.documents

        })
      //  this.props.handleSubmit(false);
    }
    render() {
        const {isSubmitted} = this.state;
        const intl = this.props.useIntl;
        return (
            <div className="general-info-tab">
                <div className="left-pane" style={{paddingTop: 10}}>

                    <Row gutter={24}>
                        <Col md={24}>
                            <Title level={4}><FormattedMessage id="app.modal.documentoriginatorcorporateuploading.corporatedocument"/></Title>
                                <div style={{paddingBottom: 10}}>
                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={ this.state.documents[
                                                "CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                                                ]
                                        }
                                        title={intl.formatMessage({id: "app.modal.documentoriginatorcorporateuploading.certificateofincorporation"})}
                                        type="CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                                        isOriginatorAttachedFile={true}
                                        fileExtension={".pdf"}
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                    />

                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
                                                ]
                                        }
                                        title={intl.formatMessage({id: "app.modal.documentoriginatorcorporateuploading.articlesofassociation"})}
                                        type="MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
                                        handleRemoveFile={this.handleRemoveFile}
                                        isOriginatorAttachedFile={true}
                                        fileExtension={".pdf"}
                                        disabled={isSubmitted}
                                    />

                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "COMPANY_SEARCH_REPORT"
                                                ]
                                        }
                                        title={intl.formatMessage({id: "app.modal.documentoriginatorcorporateuploading.companysearchreport"})}
                                        type="COMPANY_SEARCH_REPORT"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                        fileExtension={".pdf"}
                                        isOriginatorAttachedFile={true}
                                    />

                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
                                                ]
                                        }
                                        title={intl.formatMessage({id: "app.modal.documentoriginatorcorporateuploading.boardresolutionforaccountopening"})}
                                        type="BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                        fileExtension={".pdf"}
                                        isOriginatorAttachedFile={true}
                                    />
                                </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

}


export default withUseIntl(DocumentOriginatorCorporateUploading);
